import { createAction, props } from '@ngrx/store';
import { HttpError } from 'src/app/models/common/http-error.model';
import { SubmissionFilters } from '../../models/submission-filters.model';
import {
  StudySaleSubmissionModel,
  SubmissionModel,
} from '../../models/submission.model';

export const GetUserSubmissions = createAction(
  '[Submissions] Get User Submissions'
);

export const GetUserSubmissionsSuccess = createAction(
  '[Submissions] Get User Submissions Success',
  props<{ submissions: SubmissionModel[] }>()
);

export const GetUserSubmissionsFailure = createAction(
  '[Submissions] Get User Submissions Failure',
  props<{ err: HttpError }>()
);

export const SetFilters = createAction(
  '[Submissions] Set Filters',
  props<{ filters: SubmissionFilters }>()
);

export const ResetFilters = createAction('[Submissions] Reset Filters');

export const CancelSubmissionById = createAction(
  '[Submissions] Cancel Submission By Id',
  props<{
    saleId: number;
    horseId: number;
    submissionId: number;
  }>()
);

export const CancelSubmissionByIdSuccess = createAction(
  '[Submissions] Cancel Submission By Id Success',
  props<{ submissionId: number }>()
);

export const CancelSubmissionByIdFailure = createAction(
  '[Submissions] Cancel Submission By Id Failure',
  props<{ err: any }>()
);

export const CancelStudySubmission = createAction(
  '[Submissions] Cancel Study Submission',
  props<{
    submission: StudySaleSubmissionModel;
    studyId: number;
  }>()
);

export const CancelStudySubmissionSuccess = createAction(
  '[Submissions] Cancel Study Submission Success',
  props<{ submissionId: number }>()
);

export const CancelStudySubmissionFailure = createAction(
  '[Submissions] Cancel Study Submission Failure',
  props<{ err: any }>()
);

export const CancelDraftSubmission = createAction(
  '[Submissions] Cancel Draft Submission',
  props<{
    saleId: number;
    horseId: number;
  }>()
);

export const CancelDraftSubmissionSuccess = createAction(
  '[Submissions] Cancel Draft Submission Success',
  props<{ submissionId: number }>()
);

export const CancelDraftSubmissionFailure = createAction(
  '[Submissions] Cancel Draft Submission Failure',
  props<{ err: any }>()
);

export const GetSubmissionsByStudyId = createAction(
  '[Submissions] Get Submissions By Study Id',
  props<{ studyId: number }>()
);

export const GetSubmissionsByStudyIdSuccess = createAction(
  '[Submissions] Get Submissions By Study Id Success',
  props<{ submissions: StudySaleSubmissionModel[] }>()
);

export const GetSubmissionsByStudyIdFailure = createAction(
  '[Submissions] Get Submissions By Study Id Failure',
  props<{ err: HttpError }>()
);

export const GetDraftSubmissionsCount = createAction(
  '[Submissions] Get Draft Submission Count'
);

export const GetDraftSubmissionsCountSuccess = createAction(
  '[Submissions] Get Draft Submission Count Success',
  props<{ draftSubmissionCount: number }>()
);

export const GetDraftSubmissionsCountFailure = createAction(
  '[Submissions] Get Draft Submission Count Failure',
  props<{ err: HttpError }>()
);
